(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evo-legal-guarantee-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('evo-legal-guarantee-dialog');
    if (!dialog || dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';

    let openingButton = null;

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-evo-legal-guarantee-open]');
      if (openButton) {
        openingButton = openButton;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      if (event.target.closest('[data-evo-legal-guarantee-close]')) dialog.close();
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      if (openingButton) openingButton.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evo-mobile-nav"] && !Shopify.designMode) return;
  try {
    const evoCartSource = document.querySelector('.header__action-item--cart .header__cart-count');
  const evoCartBadge = document.querySelector('[data-evo-mobile-cart-count]');
  if (evoCartSource && evoCartBadge) {
    const syncEvoCart = () => {
      const count = Number.parseInt(evoCartSource.textContent, 10) || 0;
      evoCartBadge.textContent = String(count);
      evoCartBadge.hidden = count === 0;
    };
    new MutationObserver(syncEvoCart).observe(evoCartSource, { childList: true, characterData: true, subtree: true });
    syncEvoCart();
  }
  } catch(e) { console.error(e); }
})();

})();
